import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import ContentWrapper from '../Layout/ContentWrapper';

const styles = {
  marginLeft: '10%',
  marginRight: '10%',
  textAlign: 'center',
  fontSize: '25px',
};

const buttonWrapperStyle = {
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '0px',
}

const SOModalStyle = {
  width: '430px',
  height: '210px',
  marginLeft: '-15%',
};

const Modal = ({ content, onConfirm, onCancel }) => (
  <ContentWrapper>
    <Row>
      <Col xs={12} style={{ padding: '20px' }}>
        <div style={styles}>
          {
            content
          }
        </div>
      </Col>
    </Row>
    <Row>
    </Row>
  </ContentWrapper>);

const SOConfirmationModal = ({
  title, content, onConfirm, onCancel, isVisible
}) => (
    <SkyLightStateless
      dialogStyles={SOModalStyle}
      isVisible={isVisible}
      onCloseClicked={onCancel}
      title={title}
    >
      <Modal
        content={
            <div>
                <h3 style={styles.sectionPadding}>
                    <Translate value="msg_existing_purchase_order_for_customer" />
                </h3>
                <div>
                    <button
                        className="btn btn-primary"
                        onClick={onConfirm}
                        style={{marginRight: '10px'}}
                    >
                        <i className="fa fa-check" />
                        <Translate value="yes" />
                    </button>
                    <button
                        className="btn btn-danger"
                        onClick={onCancel}
                    >
                        <i className="fa fa-close" />
                        <Translate value="No" />
                    </button>
                </div></div>
        }
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </SkyLightStateless>);

export default SOConfirmationModal;


// WEBPACK FOOTER //
// ./master/jsx/components/Common/SOConfirmationModal.jsx